// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2bDQ_","info":"UpdateTermsInfo_info__2hVNm"};